var map = {
	"./de.json": [
		2022,
		79
	],
	"./de_CH.json": [
		2023,
		80
	],
	"./de_DE.json": [
		2024,
		81
	],
	"./en.json": [
		710
	],
	"./en_CA.json": [
		2025,
		2
	],
	"./en_CH.json": [
		2026,
		5
	],
	"./en_GB.json": [
		2027,
		7
	],
	"./en_ZA.json": [
		1981,
		4
	],
	"./fr.json": [
		2028,
		82
	],
	"./fr_CA.json": [
		2029,
		5
	],
	"./fr_CH.json": [
		2030,
		5
	],
	"./it.json": [
		2031,
		83
	],
	"./it_CH.json": [
		2032,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 843;
module.exports = webpackAsyncContext;